var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { NamedRoutes } from "./NamedRoutes";
import { UserType } from "healthex-common/user.dtos";
import { NOT_LOADED } from "../Infra/RemoteData";
export class WelcomeOrgUserInviteViewModel {
    constructor(container) {
        this.routingUIManager = container.routingUIManager;
        this.welcomeUserUIManager = container.welcomeUserUIManager;
        this.authManager = container.authManager;
        this.organizationsManager = container.organizationsManager;
    }
    async onCancel() {
        if (this.authManager.orgId === null)
            return;
        if (this.authManager.userType !== UserType.HEALTHCARE_ORGANIZATION && this.authManager.userType !== UserType.EXTERNAL_RESEARCHER)
            return;
        await this.organizationsManager.editOrganization(this.authManager.orgId, {
            type: this.authManager.userType,
            setupComplete: true,
        });
        if (this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION) {
            this.routingUIManager.navigateTo(NamedRoutes.HEALTHCARE_ORG_ANALYTICS);
        }
        else if (this.authManager.isDataUser) {
            this.routingUIManager.navigateTo(NamedRoutes.PROJECTS);
        }
    }
    get description() {
        var _a, _b;
        if (this.organizationsManager.myOrganization.value === NOT_LOADED)
            return null;
        return this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION
            ? `Add key stakeholders from ${this.orgName} to drive collaboration and innovation within your organization.`
            : this.authManager.isDataUser
                ? `Add other users based at ${this.orgName} to drive collaboration and innovation within your organization.`
                : `Add other researchers and colleagues based at ${(_b = (_a = this.organizationsManager.myOrganization.value) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "[No org name specified]"} to drive collaboration and innovation within your organization.`;
    }
    get invitingText() {
        return this.authManager.isDataUser
            ? "Inviting many users? Skip this step and enable Single Sign-On (SSO) later from your admin settings. SSO lets your team log in with one set of credentials, making account creation a breeze and streamlining access to HealthEx."
            : "Inviting many colleagues? Skip this step and enable Single Sign-On (SSO) later from your admin settings. SSO lets your team log in with one set of credentials, making account creation a breeze and streamlining access to HealthEx.";
    }
    get showProgressBar() {
        if (!this.routingUIManager.currentRoute)
            return false;
        return true;
    }
    get progressBarPercentage() {
        return this.welcomeUserUIManager.progressBarPercentage;
    }
    get orgName() {
        return this.authManager.orgName;
    }
}
__decorate([
    computed
], WelcomeOrgUserInviteViewModel.prototype, "description", null);
__decorate([
    computed
], WelcomeOrgUserInviteViewModel.prototype, "invitingText", null);
__decorate([
    computed
], WelcomeOrgUserInviteViewModel.prototype, "showProgressBar", null);
__decorate([
    computed
], WelcomeOrgUserInviteViewModel.prototype, "progressBarPercentage", null);
__decorate([
    computed
], WelcomeOrgUserInviteViewModel.prototype, "orgName", null);
